//TODO: retornar o winston depois do PR (https://github.com/winstonjs/winston-transport/pull/30).

export const createLogger = label => {
  return {
    error: error => {
      if (process.env.REACT_APP_ENVIRONMENT === 'production' && window.newrelic) {
        window.newrelic.noticeError(error);
      }

      if (console && console.log) {
        console.log(`error:${label}`);
        console.log(error);
      }
    },
  };
};
